enum DateTypeShort {
    D = 'd',
    M = 'm',
    Y = 'y',
    W = 'w',
}

export default DateTypeShort;
